import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import EMIracker2ReasonUpdateModalUI from './EMIracker2ReasonUpdateModalUI.js'

class EMIracker2ReasonUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      reason: '',
      reasonError: null,
    }
  }

  render() {
    return (
      <EMIracker2ReasonUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        reason={this.state.reason}
        onReasonChange={(event) => { this.setState({ reason: event.target.value }) }}
        reasonError={this.state.reasonError}
        setReasonError={(error) => { this.setState({ reasonError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (this.props.updateMode && (!prevProps.updateMode || this.props.selectedLoanId !== prevProps.selectedLoanId)) {
      this.setState({
        reason: this.props.currentReason || '',
        reasonError: null,
        successMsg: null,
        errorList: null,
      })
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    const year = this.props.year
    const month = this.props.month
    let queryParams = []
    if (year !== undefined && year !== null && year !== '') {
      queryParams.push(`year=${year}`)
    }
    if (month !== undefined && month !== null && month !== '') {
      queryParams.push(`month=${month}`)
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : ''

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.selectedLoanId}/repayments/updateReason${queryString}`,
      this.onSubmitCallback, {
      reason: this.state.reason,
      isToCollect: this.props.isToCollect
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      const savedReason = this.state.reason
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        if (this.props.onReasonUpdateSuccess) {
          this.props.onReasonUpdateSuccess(this.props.selectedLoanId, savedReason)
        } else if (!savedReason || (typeof savedReason === 'string' && !savedReason.trim())) {
          window.location.reload()
        } else if (this.props.onRefreshClick) {
          this.props.onRefreshClick()
        }
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(EMIracker2ReasonUpdateModalSF)
